import { render, staticRenderFns } from "./Task1099s.vue?vue&type=template&id=2cfc3441"
import script from "./Task1099s.vue?vue&type=script&lang=js"
export * from "./Task1099s.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports